import { COUNTRY_DIAL_CODES, CountryDialCode } from '../../../lib/phoneValidation';

export interface CountryOption {
  value: string;
  label: string;
}

const toFilterableOption = (country: CountryDialCode): CountryOption => ({
  value: country.code,
  label: `+${country.code} ${country.name}`,
});

export const toCompactOption = (country: CountryDialCode): CountryOption => ({
  value: country.code,
  label: `+${country.code}`,
});

export const COUNTRY_OPTIONS: CountryOption[] = COUNTRY_DIAL_CODES.map(toFilterableOption);

export const PHONE_LABEL_DEFAULT = 'Mobilnummer';
export const PHONE_PLACEHOLDER_DEFAULT = '8 siffer';
export const COUNTRY_PLACEHOLDER = '+47';
export const COUNTRY_SELECT_WIDTH = '120px';
export const COUNTRY_DROPDOWN_MAX_LINES = 8;
